import axios from 'axios';
import { getProfil } from 'components/utils/FormatData';
import { ERROR_REFRESH_TOKEN, LOGIN, LOGOUT, UPDATE_TOKEN } from 'constants/constants';
import {
  AUTH_URL,
  AUTH_REALM,
  AUTH_CLIENT_ID,
  AUTH_DELAY_REFRESH,
  AUTH_REDIRECT_ROUTE,
  DEBUG_MODE,
  URL_API
} from 'constants/settings';
import Keycloak from 'keycloak-js';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';


export default function useAuthn() {
  const [state, setState] = useState({ keycloak: null, authenticated: null });
  const auth = useSelector(state => state["authentification"]);
  const dispatch = useDispatch();

  // Hook de montage
  useEffect(() => {
    if (!DEBUG_MODE) {
      const keycloak = Keycloak({
        realm: AUTH_REALM,
        clientId: AUTH_CLIENT_ID,
        "url": AUTH_URL,
        'auth-server-url': AUTH_URL,
        'ssl-required': 'external',
        resource: AUTH_CLIENT_ID,
        'public-client': true,
        'confidential-port': 0,
      });

      keycloak
        .init({ onLoad: 'login-required', checkLoginIframe: false })
        .success((authenticated) => {
          setState({ keycloak, authenticated });
          keycloak.loadUserInfo().success((userinfo) => {
            getUserInfo(keycloak.token)
              .then((res) => {
                dispatch({ type: LOGIN, payload: { user: userinfo, token: keycloak.token, profil: getProfil(res.data.role), authenticated: true } });
              })
              .catch((err) => {
                console.log(err);
              });
          });
        })
        .error(() => {
          dispatch({ type: LOGOUT });
        });
    } else {
      dispatch({
        type: LOGIN, payload: {
          user: {
            sub: "b250cc00-147f-4bd1-914d-ff2b7da2a724",
            email_verified: false,
            name: "DUPOND-ext",
            preferred_username: "dupond-ext",
            family_name: "DUPOND-ext",
            email: "martin.DUPOND-ext@sanef.com"
          },
          token: "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJERHhBcEhESFF4V202Y3dBUnFOTmI3dWQwZ1ZUdjM5R0FKbTl6bDFwMXhBIn0.eyJqdGkiOiJjYTU1YzQ4Yi04NTNmLTRiOGEtOTM2Yy02ZWVlZTExMTA3YzgiLCJleHAiOjE2MzcyMjM5MzAsIm5iZiI6MCwiaWF0IjoxNjM3MjIzNjMwLCJpc3MiOiJodHRwczovL3NlZC1xdWFsaWYuc2FuZWYuZnIvYXV0aC9yZWFsbXMvYW1lbGllIiwiYXVkIjoiYWNjb3VudCIsInN1YiI6ImIyNTBjYzAwLTE0N2YtNGJkMS05MTRkLWZmMmI3ZGEyYTcyNCIsInR5cCI6IkJlYXJlciIsImF6cCI6InNlZC1mcm9udCIsIm5vbmNlIjoiM2NmZjY0YmUtYWYyMC00MmUwLTg1NDgtOTZjNDU1NjU1M2QxIiwiYXV0aF90aW1lIjoxNjM3MjIyNzc3LCJzZXNzaW9uX3N0YXRlIjoiNDRhMTMzOGUtNDg0ZC00ZDIzLTkwOTctYjQ1NGNlMzY0NzQxIiwiYWNyIjoiMCIsImFsbG93ZWQtb3JpZ2lucyI6WyIqIl0sInJlYWxtX2FjY2VzcyI6eyJyb2xlcyI6WyJvZmZsaW5lX2FjY2VzcyIsInVtYV9hdXRob3JpemF0aW9uIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6IkpPTElCT0lTLWV4dCIsInByZWZlcnJlZF91c2VybmFtZSI6ImpvbGlib2lzLWV4dCIsImZhbWlseV9uYW1lIjoiSk9MSUJPSVMtZXh0IiwiZW1haWwiOiJuYXRoYW4uam9saWJvaXMtZXh0QHNhbmVmLmNvbSJ9.YnthueHieP-7tyYm4MwWKEsdsOj4Gd56ZE5e8gGZrN0Zt8o8Cqk_G5TWYN_6S2_D4IpgdyWv6fF7ry6EiSoQIkJU_DMeF5_uXFo6m6wz5-bBm7si6X2WpWr-lCf55HzL7vEeKrNll6fLxYrOeQwVGZDz5naTccJquM6he8ytowiuxKQGd_PxBGt0yePuCqncDJW3vf_PBIv9qHAryecfXiLB9BPj7EJLccjkeM0DAIfxK7L8oJ7u3tOYlTOXrk7YndSbiPYPLXOtVsxMctxDABtzZMNwqQXCTM3Iea5dR-F114ZY_gCHLme1d0Qo8mqFO71b1TrU7TGYKGy34sxOdA",
          profil: 1,
          authenticated: true
        }
      });
    }
  }, []);

  // Récupération d'un token valide
  const getValidToken = () => {
    if (!DEBUG_MODE) {

      // Si KeyCloak n'est pas initialisé
      if (!state.keycloak) {
        return null;
      }

      // Si le token est valable moins de 60 secondes, on le renouvelle
      state.keycloak
        .updateToken(Number(AUTH_DELAY_REFRESH ? AUTH_DELAY_REFRESH : 60))
        .success((refreshed) => {
          if (refreshed) {
            let token = state.keycloak.token;
            axios.defaults.headers.common = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
            axios.defaults.headers.delete = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
            axios.defaults.headers.get = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
            axios.defaults.headers.patch = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
            axios.defaults.headers.post = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };
            axios.defaults.headers.put = { Authorization: `Bearer ${token}`, Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json' };

            //axios.defaults.headers.common.Authorization = `Bearer ${getValidToken()}`;
            dispatch({ type: UPDATE_TOKEN, payload: { token: state.keycloak.token } });
          }
        })
        .error(() => {
          if (auth.token !== null || auth.authenticated) {
            dispatch({ type: ERROR_REFRESH_TOKEN });
          }
        });

      return state.keycloak.token;
    } else {
      return 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJERHhBcEhESFF4V202Y3dBUnFOTmI3dWQwZ1ZUdjM5R0FKbTl6bDFwMXhBIn0.eyJqdGkiOiJjYTU1YzQ4Yi04NTNmLTRiOGEtOTM2Yy02ZWVlZTExMTA3YzgiLCJleHAiOjE2MzcyMjM5MzAsIm5iZiI6MCwiaWF0IjoxNjM3MjIzNjMwLCJpc3MiOiJodHRwczovL3NlZC1xdWFsaWYuc2FuZWYuZnIvYXV0aC9yZWFsbXMvYW1lbGllIiwiYXVkIjoiYWNjb3VudCIsInN1YiI6ImIyNTBjYzAwLTE0N2YtNGJkMS05MTRkLWZmMmI3ZGEyYTcyNCIsInR5cCI6IkJlYXJlciIsImF6cCI6InNlZC1mcm9udCIsIm5vbmNlIjoiM2NmZjY0YmUtYWYyMC00MmUwLTg1NDgtOTZjNDU1NjU1M2QxIiwiYXV0aF90aW1lIjoxNjM3MjIyNzc3LCJzZXNzaW9uX3N0YXRlIjoiNDRhMTMzOGUtNDg0ZC00ZDIzLTkwOTctYjQ1NGNlMzY0NzQxIiwiYWNyIjoiMCIsImFsbG93ZWQtb3JpZ2lucyI6WyIqIl0sInJlYWxtX2FjY2VzcyI6eyJyb2xlcyI6WyJvZmZsaW5lX2FjY2VzcyIsInVtYV9hdXRob3JpemF0aW9uIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6IkpPTElCT0lTLWV4dCIsInByZWZlcnJlZF91c2VybmFtZSI6ImpvbGlib2lzLWV4dCIsImZhbWlseV9uYW1lIjoiSk9MSUJPSVMtZXh0IiwiZW1haWwiOiJuYXRoYW4uam9saWJvaXMtZXh0QHNhbmVmLmNvbSJ9.YnthueHieP-7tyYm4MwWKEsdsOj4Gd56ZE5e8gGZrN0Zt8o8Cqk_G5TWYN_6S2_D4IpgdyWv6fF7ry6EiSoQIkJU_DMeF5_uXFo6m6wz5-bBm7si6X2WpWr-lCf55HzL7vEeKrNll6fLxYrOeQwVGZDz5naTccJquM6he8ytowiuxKQGd_PxBGt0yePuCqncDJW3vf_PBIv9qHAryecfXiLB9BPj7EJLccjkeM0DAIfxK7L8oJ7u3tOYlTOXrk7YndSbiPYPLXOtVsxMctxDABtzZMNwqQXCTM3Iea5dR-F114ZY_gCHLme1d0Qo8mqFO71b1TrU7TGYKGy34sxOdA';
    }
  };

  // Gestion de la déconnexion
  const logout = useCallback(() => {

    if (!DEBUG_MODE) {
      // Si KeyCloak n'est pas initialisé
      if (!state.keycloak) {
        return;
      }

      // Déconnexion
      state.keycloak.logout({ redirectUri: `${AUTH_REDIRECT_ROUTE}` }).success(() => {
        dispatch({ type: LOGOUT });
      });

    } else {
      dispatch({ type: LOGOUT });
    }
  }, [dispatch, state.keycloak]);

  // Récupération des infos sur l'utilisateur connecté
  const getUserInfo = (token) => {
    return axios({
      method: 'get', url: URL_API + '/utilisateurs/current', headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",

      }
    });
  }

  return [getValidToken, logout];


}
